<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t('relatorio-km-automatico-detalhe') }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('despesas') }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: 'des-relatorio-km-automatico-list',
                                            })
                                        "
                                        >{{ $t('relatorio-km-automatico') }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $t('relatorio-km-automatico-detalhe')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: 'des-relatorio-km-automatico-list' })"
                        >
                            {{ $t('voltar') }}
                        </button>
                    </div>
                </div>
                <br />

                <div class="box" v-if="data != null">
                    <div class="card-title-custom mb-2">
                        <p class="is-size-4">
                            {{ $t('motivo-despesa') }}: {{ data.despesaMotivo.descricao }}
                            <i :class="data.despesaMotivo.icone.toLowerCase()"></i>
                        </p>
                    </div>
                    <hr />

                    <div class="columns is-flex-wrap">
                        <div class="column is-4">
                            {{ $t('valor') }}: <br />
                            {{ getDecimal(data.valor, null, true) }}
                        </div>
                        <div class="column is-4">
                            {{ $t('valor-km') }}: <br />
                            {{ getDecimal(data.despesaDespesaPda.valorkm, null, true) }}
                        </div>
                        <div class="column is-4">
                            {{ $t('data') }}: <br />
                            {{ data.datahorainc | moment('L') }}
                        </div>
                        <div class="column is-4">
                            {{ $t('empresa') }}: <br />
                            {{ data.empresa.nome }}
                        </div>
                        <div class="column is-4">
                            {{ $t('colaborador') }}: <br />
                            {{ data.usuario.nome }}
                        </div>
                        <div class="column is-4">
                            {{ $t('cliente') }} {{ $t('origem') }}: <br />
                            {{ data.clienteOrigem.nome }}
                        </div>
                        <div class="column is-4">
                            <!-- 
                                @70209 - Implementado toltip caso venha zerada a coordenada da tabela check
                            -->
                            {{ $t('origem') }} {{ $t('gps') }}:
                            <b-icon
                                v-if="
                                    data.checkOrigem.latitudecheckin == 0 &&
                                    data.checkOrigem.longitudecheckin == 0
                                "
                                icon="information"
                                size="is-small"
                                v-tippy
                                :title="$t('informacao-origem-gps')"
                            />
                            <br />
                            Lat {{ formatGeo(data.latitudeOrigem) }} Lng
                            {{ formatGeo(data.longitudeOrigem) }}
                        </div>
                        <div class="column is-4">
                            {{ $t('cliente') }} {{ $t('destino') }}: <br />
                            {{ data.clienteDestino.nome }}
                        </div>
                        <div class="column is-4">
                            <!-- 
                                @70209 - Implementado toltip caso venha zerada a coordenada da tabela check
                            -->
                            {{ $t('destino') }} {{ $t('gps') }}:
                            <b-icon
                                v-if="
                                    data.checkDestino.latitudecheckin == 0 &&
                                    data.checkDestino.longitudecheckin == 0
                                "
                                icon="information"
                                size="is-small"
                                v-tippy
                                :title="$t('informacao-origem-gps')"
                            />
                            <br />
                            Lat {{ formatGeo(data.latitudeDestino) }} Lng
                            {{ formatGeo(data.longitudeDestino) }}
                        </div>
                        <div class="column is-4">
                            {{ $t('distancia') }}: <br />
                            {{ (data.distancia * 0.001) | decimal(3) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RelatorioKmAutomaticoService from '@/services/despesas/RelatorioKmAutomaticoService';

export default {
    data() {
        return {
            data: null,
            service: new RelatorioKmAutomaticoService(this.$http, this.$router),
            isLoading: false,
            permissao: {},
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            'despesas',
            'relatorios',
            'des-relatorio-km-automatico'
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'relatorios' },
            });
        } else {
            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
            } else {
                this.$router.push({ name: 'des-relatorio-km-automatico' });
            }
        }
    },
    methods: {
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((res) => {
                    this.data = res.content;
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        /**
         * @70209 - Formatar as coordenadas.
         */
        formatGeo(number) {
            return number.toLocaleString('en-US', {
                minimumFractionDigits: 6,
                maximumFractionDigits: 6,
            });
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
    .page {
        position: relative;
        padding-left: 0;
    }
    .card-title-custom {
        text-align: center;
    }
    .b-table .table {
        border-collapse: collapse;
    }
    .hero-body-img {
        padding: 20px;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    @media screen and (max-width: 768px) {
        .b-table .table {
            border-collapse: separate;
        }
        .colums-mobile {
            width: 100% !important;
        }
        .b-table
            .table-wrapper.has-mobile-cards
            tr:not(.detail):not(.is-empty):not(.table-footer)
            td {
            justify-content: left;
            text-align: left;
        }
        .b-table .table-wrapper.has-mobile-cards .table-footer {
            margin-top: 15px;
            padding-left: 5px;
        }
    }
}
</style>
